import React, { useEffect, useRef, useState } from "react";
import { Typography, Button, Grid2, Box, Stack, Paper } from "@mui/material";
import "./Home.css"; // Import CSS file
import Card from "./Card";
import { cardData } from "./data";
import Lenis from "@studio-freight/lenis"; // Import Lenis for smooth scroll

const KeyFeatures = () => {
  const container = useRef(null);
  const [scrollYProgress, setScrollYProgress] = useState(0);

  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.1, // Optional: Adjust the smoothing factor
      smooth: true,
    });

    // Listen for the scroll event from Lenis
    function onScroll() {
      setScrollYProgress(
        lenis.scroll.y / (document.body.scrollHeight - window.innerHeight)
      );
    }

    // Add the event listener
    lenis.on("scroll", onScroll);

    // Animation frame for smooth scroll
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.off("scroll", onScroll); // Cleanup on unmount
    };
  }, []);
  return (
    <Box className="clients-section">
      <Typography
        className="features-title"
        sx={{
          color: "#002367",
          fontFamily: "Light",
          fontSize: { xs: 24, sm: 32, md: 42 }, // Responsive font size
          fontWeight: "700",
          lineHeight: "35px",
          display: "flex",
          justifyContent: "center",
          marginTop: { xs: 6, sm: 6, md: 8, lg: 10, xl: 12 },
          marginBottom: { xs: 3, sm: 3, md: 4, lg: 6, xl: 6 },
        }}
      >
        Our Key Features
      </Typography>
      <Grid2
        ref={container}
        sx={{
          paddingTop: { xs: 2, sm: 2, md: 5, lg: 5, xl: 4 },
          paddingBottom: { xs: 2, sm: 2, md: 5, lg: 5, xl: 8 },
        }}
      >
        {cardData.map((project, i) => {
          const targetScale = 1 - (cardData.length - i) * 0.05;
          return (
            <Card
              key={`p_${i}`}
              i={i}
              {...project}
              progress={scrollYProgress}
              range={[i * 0.25, 1]}
              targetScale={targetScale}
            />
          );
        })}
      </Grid2>
    </Box>
  );
};

export default KeyFeatures;
